var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateQuestionLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 1.50684L15.2653 3.56753L17.3259 4.66656L15.2653 5.76559L14.1663 7.82629L13.0672 5.76559L11.0065 4.66656L13.0672 3.56753L14.1663 1.50684ZM6.66623 4.111L8.88844 8.27767L13.0551 10.4999L8.88844 12.7221L6.66623 16.8888L4.44401 12.7221L0.277344 10.4999L4.44401 8.27767L6.66623 4.111ZM16.3884 14.111L14.9996 11.5069L13.6107 14.111L11.0065 15.4999L13.6107 16.8888L14.9996 19.493L16.3884 16.8888L18.9926 15.4999L16.3884 14.111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateQuestionLight);
export default __webpack_public_path__ + "static/media/generate-question-light.6e0c9924dc338070c9d998aba4873e4d.svg";
export { ForwardRef as ReactComponent };